import React from "react"
import SingleBlog from "../../components/Blogs/Home/SingleBlog"
import CategoryBlogs from "../../components/Category/CategoryBlogs"

export default function Category() {
  return (
    <>
      <SingleBlog />
      <CategoryBlogs />
    </>
  )
}
